import React from 'react';
import { Table, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { addCount, sortName } from '../component/Store';

const Cart = () => {
    let state = useSelector((state)=>state)
    console.log(state.cart[0].name);

    let dispatch = useDispatch();
    
    return(
        <>
            <Table>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>상품명</th>
                        <th>수량</th>
                        <th>변경하기</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        state.cart.map((v,i)=>
                            <tr key={i}>
                                <td>{state.cart[i].id}</td>
                                <td>{state.cart[i].name}</td>
                                <td>{state.cart[i].count}</td>
                                <td><button onClick={()=>
                                    dispatch(addCount(state.cart[i].id))
                                }>+</button></td>
                            </tr>
                        )
                    }                   
                </tbody>
            </Table>
            <Button variant="outline-primary" onClick={()=>{
                dispatch(sortName(state.cart.Name))
            }}>이름순정렬</Button>{' '}
        </>
    );
};

export default Cart;